 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import LOVE_1 from '@/components/love_1'
 import BOOKDESCRIPTION from '@/components/book-description'
 import TITLEPAGE from '@/components/title-page'
 import UNTITLED from '@/components/untitled'
 import COPYRIGHT from '@/components/copyright'
 import CONTENTS from '@/components/contents'
 import INTRODUCTION from '@/components/introduction'
 import VOL001 from '@/components/vol-001'
 import VOL001GAVINFUNKESMONSTERMOVIEMARATHON from '@/components/vol-001-gavin-funkes-monster-movie-marathon'
 import VOL002 from '@/components/vol-002'
 import VOL002FLICKERINGDUSKOFTHEVIDEOGOD from '@/components/vol-002-flickering-dusk-of-the-video-god'
 import VOL003 from '@/components/vol-003'
 import VOL003MICHAELTHINKSTHEHOUSEISHAUNTED from '@/components/vol-003-michael-thinks-the-house-is-haunted'
 import VOL004 from '@/components/vol-004'
 import VOL004ATROPOSGREEN from '@/components/vol-004-atropos-green'
 import VOL005 from '@/components/vol-005'
 import VOL005LASTSUNSETHOME from '@/components/vol-005-last-sunset-home'
 import VOL006 from '@/components/vol-006'
 import VOL006LOVEYOURMOTHER from '@/components/vol-006-love-your-mother'
 import VOL007 from '@/components/vol-007'
 import VOL007PROGRESSGROWSOUTOFMOTION from '@/components/vol-007-progress-grows-out-of-motion'
 import VOL008 from '@/components/vol-008'
 import VOL008WHENTHESHIFTHITSTHEFAN from '@/components/vol-008-when-the-shift-hits-the-fan'
 import VOL009 from '@/components/vol-009'
 import VOL009HYDEPARK from '@/components/vol-009-hyde-park'
 import VOL010 from '@/components/vol-010'
 import VOL010MAKEMEASTAR from '@/components/vol-010-make-me-a-star'
 import VOL011 from '@/components/vol-011'
 import VOL011ALIENPIZZA from '@/components/vol-011-alien-pizza'
 import VOL012 from '@/components/vol-012'
 import VOL012WHOEVERWRITESMONSTERS from '@/components/vol-012-whoever-writes-monsters'
 import VOL013 from '@/components/vol-013'
 import VOL013TOADMANTOADMAN from '@/components/vol-013-toad-man-toad-man'
 import VOL014 from '@/components/vol-014'
 import VOL014FALSEBAY from '@/components/vol-014-false-bay'
 import VOL015 from '@/components/vol-015'
 import VOL015ZISFORZOMBIE from '@/components/vol-015-z-is-for-zombie'
 import VOL016 from '@/components/vol-016'
 import VOL016VINEGARSYNDROME from '@/components/vol-016-vinegar-syndrome'
 import VOL017 from '@/components/vol-017'
 import VOL017BEERWITHFRIENDS from '@/components/vol-017-beer-with-friends'
 import VOL018 from '@/components/vol-018'
 import VOL018MOTIVATINGAMONSTER from '@/components/vol-018-motivating-a-monster'
 import VOL019 from '@/components/vol-019'
 import VOL019TUNNELVISIONS from '@/components/vol-019-tunnel-visions'
 import VOL020 from '@/components/vol-020'
 import VOL020OURLADYOFCELLULOID from '@/components/vol-020-our-lady-of-celluloid'
 import VOL021 from '@/components/vol-021'
 import VOL021JOSIESLASTSTRAW from '@/components/vol-021-josies-last-straw'
 import VOL022 from '@/components/vol-022'
 import VOL022THELASTDRIVEINMOVIE from '@/components/vol-022-the-last-drive-in-movie'
 import VOL023 from '@/components/vol-023'
 import VOL023WELCOMETOTHEUNDERHILLCINEMA from '@/components/vol-023-welcome-to-the-underhill-cinema'
 import LOVE_2 from '@/components/love_2'
 import ADDITIONALCOPYRIGHTINFORMATION from '@/components/additional-copyright-information'
 import ABOUTTHEEDITOR from '@/components/about-the-editor'
 import IFYOULIKED from '@/components/if-you-liked'
 import OTHERWORDFIREPRESSANTHOLOGIES from '@/components/other-wordfire-press-anthologies'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/cover",
 			"name" : "cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/book-description",
 			"name" : "book-description",
 			"component" : BOOKDESCRIPTION
 		},
 		{
 			"path" : "/title-page",
 			"name" : "title-page",
 			"component" : TITLEPAGE
 		},
 		{
 			"path" : "/untitled",
 			"name" : "untitled",
 			"component" : UNTITLED
 		},
 		{
 			"path" : "/copyright",
 			"name" : "copyright",
 			"component" : COPYRIGHT
 		},
 		{
 			"path" : "/contents",
 			"name" : "contents",
 			"component" : CONTENTS
 		},
 		{
 			"path" : "/introduction",
 			"name" : "introduction",
 			"component" : INTRODUCTION
 		},
 		{
 			"path" : "/vol-001",
 			"name" : "vol-001",
 			"component" : VOL001
 		},
 		{
 			"path" : "/vol-001-gavin-funkes-monster-movie-marathon",
 			"name" : "vol-001-gavin-funkes-monster-movie-marathon",
 			"component" : VOL001GAVINFUNKESMONSTERMOVIEMARATHON
 		},
 		{
 			"path" : "/vol-002",
 			"name" : "vol-002",
 			"component" : VOL002
 		},
 		{
 			"path" : "/vol-002-flickering-dusk-of-the-video-god",
 			"name" : "vol-002-flickering-dusk-of-the-video-god",
 			"component" : VOL002FLICKERINGDUSKOFTHEVIDEOGOD
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js